import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api-service/api.service';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.css'],
})
export class SubscriptionsComponent implements OnInit, AfterViewInit, OnDestroy {
  // Enum/mapping for status
  statusMap: { [key: string]: string } = {
    pending: 'În așteptare',
    accepted: 'Acceptat',
    rejected: 'Respins',
    userActionNeeded: 'Acțiune utilizator',
    expired: 'Expirat',
    active: 'Activ',
  };

  // Enum/mapping for personType
  personTypeMap: { [key: string]: string } = {
    1: 'Persoană fizică',
    2: 'Persoană juridică',
  };

  // Enum/mapping for zone
  zoneMap: { [key: string]: string } = {
    none: '-',
    zone2: 'Stradal Zona 2 (marcaj alb)',
    zone2legal: 'Stradal Zona 2 (marcaj alb)',
    riparian: 'Riveran Stradal',
    home: 'Rezidențial Stradal',
    multiStoreyCarPark: 'Parcări etajate/subterane',
    multiStoreyCarParkRiparian: 'Parcări etajate/subterane - Riveran',
    multiStoreyCarParkLegal: 'Parcări etajate/subterane',
    multiStoreyCarParkMotorcycle: 'Parcări etajate/subterane - Motocicletă',
    truck: 'Parcări TIR',
  };

  offstreetIdentificationTypeMap: { [key: string]: string } = {
    21: 'Implicit',
    52: 'Cod QR',
    54: 'Card de acces',
  };

  offstreetIdentificationTypeOptions: Array<{ value: string; label: string }> = [];

  private identificationTypeSet = new Map<string, string>();
  private dateRangeSubscription?: Subscription;
  private identificationTypeSubscription?: Subscription;

  @ViewChild('filtersWrapper') filtersWrapper?: ElementRef<HTMLDivElement>;
  filtersReady = false;

  constructor(
    private apiService: ApiService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.form = this.fb.group({
      offstreetIdentificationType: new FormControl(''),
      dateRange: new FormGroup({
        start: new FormControl(),
        end: new FormControl(),
      }),
    });

    this.initializeIdentificationTypeOptions();
  }

  clearDateRange() {
    const dateRangeControl = this.form.get('dateRange');
    if (dateRangeControl) {
      dateRangeControl.reset();
      this.subscriptionsData = [];
    }
  }

  formatLocation(row: any): any {
    if (row.offstreetContractId !== null && row.offstreetConsumerId !== null) {
      return `<span class="location-column">${row.location}
                <span class="location-column-tooltip">(${row.offstreetContractId}, ${row.offstreetConsumerId})</span>
              </span>`;
    } else {
      return `<span>${row.location || '-'}</span>`;
    }
  }

  formatIdentificationType(row: any): any {
    // return (
    //   this.offstreetIdentificationTypeMap[row.offstreetIdentificationType] ||
    //   row.offstreetIdentificationType ||
    //   '-'
    // );
    return row.offstreetIdentificationType
      ? `<span>[${row.offstreetIdentificationType}] ${
          this.offstreetIdentificationTypeMap[row.offstreetIdentificationType]
            ? ' - ' +
              this.offstreetIdentificationTypeMap[
                row.offstreetIdentificationType
              ]
            : ''
        }`
      : '-';
  }

  form: FormGroup;
  startDate: any;
  endDate: any;
  isLoading = true;
  search = '';
  subscriptionsData: any = [];
  dtOptions: DataTables.Settings = {};
  currentSortParam = '';

  ngOnInit(): void {
    this.setupFilterSubscriptions();
    this.dtOptions = {
      pagingType: 'full',
      ordering: true,
      processing: true,
      serverSide: true,
      searching: true,
      search: true,
      columns: [
        {
          title: 'Nume',
          data: 'firstName',
        },
        {
          title: 'Prenume',
          data: 'lastName',
        },
        {
          title: 'E-mail',
          data: 'email',
        },
        {
          title: 'Număr de înmatriculare',
          data: 'licensePlate',
        },
        {
          title: 'Tip',
          data: 'type',
        },
        {
          title: 'Denumire abonament',
          data: 'description',
        },
        {
          title: 'Locație',
          data: 'location',
        },
        { title: 'Număr card', data: 'cardNumber' },
        {
          title: 'Tip identificare',
          data: 'offstreetIdentificationType',
        },
        {
          title: 'Status',
          data: 'status',
        },
        {
          title: 'Data de început',
          data: 'startDate',
          render: (data: any, type: any, row: any, meta: any) => {
            const formattedDate = this.datePipe.transform(
              data,
              'dd-MM-yyyy, HH:mm:ss'
            );
            return formattedDate || '-';
          },
        },
        {
          title: 'Data de sfârșit',
          data: 'endDate',
          render: (data: any, type: any, row: any, meta: any) => {
            const formattedDate = this.datePipe.transform(
              data,
              'dd-MM-yyyy, HH:mm:ss'
            );
            return formattedDate || '-';
          },
        },
      ],
      ajax: (data: any, callback, settings) => {
        this.isLoading = true;
        const identificationTypeFilter =
          this.form.get('offstreetIdentificationType')?.value || '';
        this.apiService
          .getAllSubscriptions(
            data.search.value,
            data.length,
            data.start,
            [], // statuses - empty array for now
            this.startDate,
            this.endDate,
            this.currentSortParam,
            identificationTypeFilter
          )
          .subscribe(
            (response: any) => {
              this.subscriptionsData = response.results.map((row: any) => {
                return {
                  firstName: row.User?.firstName || '-',
                  lastName: row.User?.lastName || '-',
                  email: row.User?.email || '-',
                  // personType:
                  //   this.personTypeMap[row.personType] || row.personType || '-',
                  licensePlate: row.LicensePlate?.licensePlate || '-',
                  type: this.zoneMap[row.type] || row.type || '-',
                  description: row.description || '-',
                  location: this.formatLocation(row),
                  status: this.statusMap[row.status] || row.status || '-',
                  startDate: row.startDate || '-',
                  endDate: row.endDate || '-',
                  cardNumber: row.cardNumber || '-',
                  offstreetIdentificationType:
                    this.formatIdentificationType(row),
                  offstreetIdentificationTypeRaw:
                    row.offstreetIdentificationType || '',
                  offstreetIdentificationTypeLabel:
                    row.offstreetIdentificationTypeLabel || '',
                };
              });

              this.updateIdentificationTypeOptions(response.results);

              setTimeout(() => {
                callback({
                  draw: data.draw,
                  data: this.subscriptionsData,
                  recordsTotal: response.total,
                  recordsFiltered: response.total,
                });
              }, 50);
            },
            (error: any) => {
              console.error('API Error:', error);
              this.isLoading = false;
            }
          );
      },

      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        },
      },
      initComplete: () => {
        this.attachFiltersToSearch();
      },
    };
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.attachFiltersToSearch());
  }

  isDateRangeSelected(): boolean {
    const startDate = this.form.get('dateRange.start')?.value;
    const endDate = this.form.get('dateRange.end')?.value;
    return !!startDate && !!endDate;
  }

  sortTable(columnName: string) {
    this.currentSortParam =
      this.currentSortParam === `${columnName}|asc`
        ? `${columnName}|desc`
        : `${columnName}|asc`;
  }

  ngOnDestroy(): void {
    this.dateRangeSubscription?.unsubscribe();
    this.identificationTypeSubscription?.unsubscribe();
  }

  private setupFilterSubscriptions(): void {
    const dateRangeControl = this.form.get('dateRange');
    if (dateRangeControl) {
      this.dateRangeSubscription = dateRangeControl.valueChanges.subscribe(
        (range: { start?: any; end?: any }) => {
          const normalizedStart = this.normalizeDateValue(range?.start);
          const normalizedEnd = this.normalizeDateValue(range?.end);

          if (normalizedStart && normalizedEnd) {
            const shouldReload =
              normalizedStart !== this.startDate ||
              normalizedEnd !== this.endDate;

            this.startDate = normalizedStart;
            this.endDate = normalizedEnd;

            if (shouldReload) {
              this.subscriptionsData = [];
              this.reloadDataTable();
            }
          } else if (!normalizedStart && !normalizedEnd) {
            if (this.startDate || this.endDate) {
              this.startDate = '';
              this.endDate = '';
              this.subscriptionsData = [];
              this.reloadDataTable();
            }
          }
        }
      );
    }

    const identificationControl = this.form.get(
      'offstreetIdentificationType'
    );
    if (identificationControl) {
      this.identificationTypeSubscription = identificationControl.valueChanges.subscribe(
        () => {
          this.subscriptionsData = [];
          this.reloadDataTable();
        }
      );
    }
  }

  private normalizeDateValue(value: any): string {
    if (!value) {
      return '';
    }

    if (value instanceof Date) {
      return this.datePipe.transform(value, 'yyyy-MM-dd') || '';
    }

    const parsedDate = new Date(value);
    if (!isNaN(parsedDate.getTime())) {
      return this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
    }

    return typeof value === 'string' ? value : '';
  }

  private reloadDataTable(): void {
    const tableElement = $('#subscriptionsDataTable');
    if (
      tableElement &&
      tableElement.length &&
      typeof $.fn.DataTable !== 'undefined' &&
      ($.fn.DataTable as any).isDataTable(tableElement[0])
    ) {
      tableElement.DataTable().ajax.reload();
    }
  }

  private initializeIdentificationTypeOptions(): void {
    Object.entries(this.offstreetIdentificationTypeMap).forEach(
      ([value, label]) => {
        if (!this.identificationTypeSet.has(value)) {
          this.identificationTypeSet.set(value, label);
        }
      }
    );

    this.offstreetIdentificationTypeOptions = Array.from(
      this.identificationTypeSet.entries()
    ).map(([value, label]) => ({ value, label }));
  }

  private updateIdentificationTypeOptions(rows: any[]): void {
    let hasChanges = false;

    rows.forEach((row: any) => {
      const typeValue =
        row.offstreetIdentificationTypeRaw ?? row.offstreetIdentificationType;
      if (!typeValue) {
        return;
      }

      const value = String(typeValue);
      const label =
        this.offstreetIdentificationTypeMap[value] ||
        row.offstreetIdentificationTypeLabel ||
        '';

      if (!this.identificationTypeSet.has(value)) {
        this.identificationTypeSet.set(value, label);
        if (label && !this.offstreetIdentificationTypeMap[value]) {
          this.offstreetIdentificationTypeMap[value] = label;
        }
        hasChanges = true;
      }
    });

    if (hasChanges) {
      this.offstreetIdentificationTypeOptions = Array.from(
        this.identificationTypeSet.entries()
      )
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(([value, label]) => ({ value, label }));
    }
  }

  private attachFiltersToSearch(): void {
    const wrapperEl = this.filtersWrapper?.nativeElement;
    if (!wrapperEl) {
      return;
    }

    const filterContainer = document.querySelector(
      '#subscriptionsDataTable_filter'
    );

    if (!filterContainer) {
      return;
    }

    if (!filterContainer.contains(wrapperEl)) {
      filterContainer.classList.add('subscriptions-filter-row');
      const searchLabel = filterContainer.querySelector('label');
      if (searchLabel) {
        searchLabel.classList.add('subscriptions-filter-search');
      }
      filterContainer.insertBefore(wrapperEl, filterContainer.firstChild);
    }

    if (!this.filtersReady) {
      this.filtersReady = true;
      this.cdr.detectChanges();
    }
  }
}
